import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import {
  Configuration,
  CreateConfigurationParams,
  UpdateConfigurationParams,
  ConfigurationKey
} from '~core/models/configuration.models';
import { ApiConstantsService } from '~core/services/api-constants.service';
import { HttpClient, HttpContext } from '@angular/common/http';
import { SKIP_ERROR_INTERCEPTOR } from '~backoffice/app/~shared/constants/global.constants';

@Injectable()
export class ConfigurationService {
  private _httpClient = inject(HttpClient);
  private _apiConstantsService = inject(ApiConstantsService);

  get apiUrl(): string {
    return this._apiConstantsService.configurationUrl;
  }

  create(data: CreateConfigurationParams): Observable<Configuration> {
    return this._httpClient.post<Configuration>(this.apiUrl, data, {
      context: new HttpContext().set(SKIP_ERROR_INTERCEPTOR, true)
    });
  }

  read(key: ConfigurationKey): Observable<Configuration> {
    return this._httpClient.get<Configuration>(`${this.apiUrl}/${key}`, {
      context: new HttpContext().set(SKIP_ERROR_INTERCEPTOR, true)
    });
  }

  patch(
    key: ConfigurationKey,
    data: UpdateConfigurationParams
  ): Observable<Configuration> {
    return this._httpClient.patch<Configuration>(
      `${this.apiUrl}/${key}`,
      data,
      {
        context: new HttpContext().set(SKIP_ERROR_INTERCEPTOR, true)
      }
    );
  }

  update(
    key: ConfigurationKey,
    data: UpdateConfigurationParams
  ): Observable<Configuration> {
    return this._httpClient.put<Configuration>(`${this.apiUrl}/${key}`, data, {
      context: new HttpContext().set(SKIP_ERROR_INTERCEPTOR, true)
    });
  }
}
